import { ArrowRight } from 'lucide-react'
import { useCallback, useState } from 'react'

import type { ButtonProps } from '@/_components/ui/button'
import { Button } from '@/_components/ui/button'
import { Dialog, DialogContent, DialogTrigger } from '@/_components/ui/dialog'
import { cn } from '@/_lib/utils'
import type {
  TBulkSimulateApplicationInputDTO,
  TSimulateApplicationOutputDTO,
} from '@doutorsim/shared/applications'

import type { TExposedFacilityDTO } from '@doutorsim/shared/facilities'
import { CreateApplicationByCompanyForm } from './create-person-by-company-form'

interface CreatePersonButtonProps extends Pick<ButtonProps, 'type' | 'className' | 'disabled'> {
  company?: TExposedFacilityDTO
  simulationData?: TBulkSimulateApplicationInputDTO
  selectedInstallment?: TSimulateApplicationOutputDTO
  label?: string
}

export enum EFillingType {
  COMPANY = 'company',
  PERSON = 'person',
}

export const CreatePersonButton = ({
  company,
  simulationData,
  selectedInstallment,
  label,
  ...args
}: CreatePersonButtonProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const handleOpenDialog = useCallback(() => {
    setIsDialogOpen(true)
  }, [])

  const dialogContentClass = cn('min-w-[336px] transition-none', 'max-w-[640px]')

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger asChild>
        <Button
          size="default"
          className={cn('flex items-center gap-1 font-bold text-brand-grayscale-1', args.className)}
          onClick={handleOpenDialog}
          type={args.type}
          disabled={args.disabled}
        >
          {label ?? 'Nova solicitação'}
          <ArrowRight size={16} />
        </Button>
      </DialogTrigger>

      <DialogContent className={dialogContentClass}>
        <CreateApplicationByCompanyForm
          facility={company}
          simulationData={simulationData}
          selectedInstallment={selectedInstallment}
          setIsDialogOpen={setIsDialogOpen}
        />
      </DialogContent>
    </Dialog>
  )
}
